(ns client-portal.client.conversations.individual.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [clojure.string :as s]
            [shared.core.components.auth0.data :as auth0.d]
            [shared.core.reactive :as re]
            [shared.core.time :as t]
            [shared.core.util :as util]))

(def root-path [:conversations :individual])
(def by-id-path (conj root-path :by-id))

(defn with-display-details [{:keys [location-name location-brand-id location-city location-state-code
                                    franchise-group-cohort-ids phone-call-timestamp] :as conv}
                            franchise-group-data]
  (assoc conv :location-name+brand-id (str location-name (when location-brand-id (str " (" location-brand-id ")")))
              :location-city-state (some->> [(some-> location-city (util/capitalize-words))
                                             (some-> location-state-code (s/upper-case))]
                                            (filter #(not (s/blank? %)))
                                            (s/join ", ")
                                            (s/trim))
              :franchise-group-label (some->> franchise-group-cohort-ids (first) (get franchise-group-data) :label)
              :phone-call-timestamp-formatted (some-> phone-call-timestamp
                                                      (t/utc->local)
                                                      (t/as-format "MMM d, y h:mm A"))))

(re/reg-auth0-loader
  :conversations/load-individual-data
  (fn [[[_ conversation-id]]]
    (conj by-id-path conversation-id))
  (fn [db [_ conversation-id]]
    (when-let [concept-id (concepts.d/current-concept-id db)]
      {:method :get
       :url (str "/api/conversations/" conversation-id)
       :query-params {:concept-id concept-id}}))
  :transf (fn [resp] (or (some-> resp :body (util/->kebab-case-keywords))
                         ""))
  :error-transf (fn [] {}))

(re/reg-auth0-load-sub
  :conversations/individual-data-
  (fn [_ conversation-id]
    (conj by-id-path conversation-id))
  :conversations/load-individual-data)

(re/reg-event-db
  :conversations/active-jump-to-time re/middleware
  (fn [db [jump-to]]
    (when-let [audio-el (.getElementById js/document "conversation-audio-player")]
      (.play audio-el)
      (set! (.-currentTime audio-el) (/ jump-to 1000)))
    db))
